import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {RequestService} from "../request/request.service";
import {LegacyInitializer} from "../initialization/legacy.initializer";
import {LocationService} from "../location/location.service";

/**
 * A placeholder for an initializer that retrieves the base application data
 * for servicely from the server. It would call controller='servicely.core.Application' method='getApplicationData'
 * either using the HttpClient or a data service that is equivalent to RequestFactory.js
 */
@Injectable()
export class SettingsInitializer {
  data: any = {};

  // LocationService only here to get it initialised before it is used on the KO side. Needs to be redone.
  constructor(private http: HttpClient,
              private requestService: RequestService,
              private legacyInitializer: LegacyInitializer,
              private locationService: LocationService) {
  }

  load(): any {
    const that = this;
    return new Promise<void>((resolve, reject) => {

      this.legacyInitializer.legacyLoaded.subscribe((e) => {
          const successFunc = (response) => {
            that.data = response.data;
            resolve();
          };

          const errorFunc = (response) => {
            alert("We encountered an error when loading the Servicely client:\n" + response.responseJSON.errors.join("\n"));
            reject();
          };

          (window as any).KO_REQUEST_FACTORY_BRIDGE.getApplicationData(successFunc, errorFunc);
        });
      });
  }

  get(): any {
    return this.data;
  }
}
